import { ContentViewModel } from '@levelapp/softfabric';
export default class CheckBoxListViewModel extends ContentViewModel {
    constructor(view) {
        super(view);
        // The Intial State 
        this.initialState({
            ids: [],
        });
        // BINDINGS
        this.onCheck = this.onCheck.bind(this);
        this.IdInState = this.IdInState.bind(this);
        this.removeId = this.removeId.bind(this);
        this.addId = this.addId.bind(this);
    }
    OnClickedValue() {
        this.props().OnClickedValue(this.state().ids);
    }
    onCheck(id) {
        if (this.IdInState(id)) {
            this.removeId(id);
        }
        else {
            this.addId(id);
        }
    }
    removeId(id) {
        var tmp = this.state().ids.slice(0);
        var toDelete = 0;
        for (var i = 0; i < tmp.length; i++) {
            if (id == tmp[i]) {
                toDelete = i;
                break;
            }
        }
        tmp.splice(toDelete, 1);
        this.setField((previousState) => previousState.ids = tmp);
    }
    addId(id) {
        var tmp = this.state().ids.slice(0);
        tmp.push(id);
        this.OnClickedValue();
        this.setField((previousState) => previousState.ids = tmp);
    }
    IdInState(id) {
        var boolean = false;
        var i = 0;
        this.state().ids.forEach((element) => {
            if (element == id) {
                boolean = true;
            }
            i++;
        });
        if (i == this.state().ids.length) {
            return boolean;
        }
        else {
            return boolean;
        }
    }
}
